<div class="container-fluid p-0">
  <div class="hpanel">
    <div class="panel-body b-r-6">
      <div class="card">
        <div class="card-header p-10-30">
          <h6> Manage Job/Candidate slots to all users in your organization</h6>
        </div>
        <div class="card-body">
          <app-plan-card  [isJobs]="true"  [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
          <div class="row">
            <div class="col-sm-12">
              <app-customer-search [placeholder]="'Search by user, email or gigsumo ID'"></app-customer-search>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 custom-datatable">
              <!-- Empty state -->
              <div *ngIf="listToShow.length === 0" class="datatable-empty-state">
                <app-nodata-found
                  [title]="['No job/candidate slots found']"
                  [screen]="'EMPTY'"
                  [buttonShow]="false">
                </app-nodata-found>
              </div>

              <!-- Datatable with data -->
              <div *ngIf="listToShow.length > 0">
                <ngx-datatable  #sortTable (sort)="onSort($event)" class="bootstrap" [rows]="listToShow" [columnMode]="'force'" [headerHeight]="40"
                  [footerHeight]="50" [rowHeight]="'auto'" [limit]="5" [selectAllRowsOnPage]="false"
                  [externalPaging]="true" [count]="totalUsers" [scrollbarH]="true" [offset]="userPayload.page"
                  [limit]="10" (select)='onSelect($event)' (page)="nextPage($event)">
                  <ngx-datatable-column cellClass="colValuesync" name="Gigsumo ID"
                  prop="gigsumoNo"></ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="User" prop="fullName">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <div class="cell-flex" *ngIf="row.isSuperAdmin">
                        <div class="cell-item">
                          <ng-icon name="tablerCrown" class="crown cu-crown-icon"></ng-icon>
                        </div>
                        <div class="cell-item">
                          <label style="margin-bottom: 0px !important;">
                            {{row.fullName}}
                          </label>
                        </div>
                      </div>
                      <div *ngIf="!row.isSuperAdmin">
                        <label style="margin-bottom: 0px !important;">
                          {{row.fullName}}
                        </label>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" [width]="200" name="Email ID"
                    prop="username"></ngx-datatable-column>
                  <ngx-datatable-column name="Role" prop="userType" [width]="150">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      {{ row.userType | MTAPipe: 'convertMTA' | titlecase }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Slots Allowed" prop="memberShipType">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{row.benefitsUsageAndBalance?.actual}}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Slots Used" prop="userCount">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{row.benefitsUsageAndBalance?.utilized}}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column *ngIf="MemberShipType !='Free' " cellClass="colValuesync" name="Featured Allowed" prop="memberShipType">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{getPlanBenfits(row, 'JOBS_CANDIDATE_SPOTLIGHTS')?.actual}}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column *ngIf="MemberShipType !='Free' " cellClass="colValuesync" name="Featured Used" prop="userCount">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{getPlanBenfits(row, 'JOBS_CANDIDATE_SPOTLIGHTS')?.utilized}}
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column cellClass="colValuesync" name="Start Date" prop="createdOn">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <label>
                        {{row.createdOn | timezoneDate:'MM/dd/yyyy'}}
                      </label>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Last Active" prop="lastLoggedIn">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <label>
                        {{row.lastLoggedIn | timezoneDate:'MM/dd/yyyy'}}
                      </label>
                    </ng-template>
                  </ngx-datatable-column>

                  <ng-container *ngIf="MemberShipType != 'Free'">
                    <ngx-datatable-column name="Plan Access" prop="planAccessStatus">
                      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div style="margin-left: 5px;" [ngStyle]="{'padding-inline-end': value === 'ACTIVE' ? '11px' : ''}">
                          <label [ngClass]="{'active-status-table': value === 'ACTIVE', 'inactive-status-table': value !== 'ACTIVE'}" class="capitalize-first">
                            {{ value === 'ACTIVE' ? 'Given' : 'Not Given' }}
                          </label>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>  
                  </ng-container>  
                  
                  <ngx-datatable-column cellClass="colValuesync" name="Status" prop="userStatus">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <div style="display: flex;align-items: center; gap:5px;">
                        <!-- <ng-icon name="tablerX" *ngIf="row.userStatus === 'INACTIVE'" class="pointer"  style="margin-left: 12px;"></ng-icon> -->
                        <!-- <ng-icon name="tablerBan" *ngIf="row.userStatus ==='BLOCKED'" class="pointer"  style="margin-left: 12px;"></ng-icon> -->
                        <!-- <ng-icon name="tablerCheck" *ngIf="row.userStatus ==='ACTIVE'" class="pointer"  style="margin-left: 21px;"></ng-icon> -->
                      <label
                        [ngClass]="{'active-status-table': row.userStatus === 'ACTIVE', 'inactive-status-table': row.userStatus === 'INACTIVE' || row.userStatus === 'BLOCKED'}"
                        class="capitalize-first">{{ row?.userStatus}}</label>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                    <ngx-datatable-column cellClass="colValuesync"  [width]="120" name="Actions" prop="name">
                      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div class="wrapper">
                          <span class="action-items">
                            <ng-icon name="tablerEye" class="svg-position" (click)="openViewModal(row)"></ng-icon>
                          </span>
                          <span *ngIf="role === 'SUPERADMIN' && ['Starter','Growth','ScaleX'].includes(MemberShipType) && row?.planAccessStatus === 'ACTIVE'"class="action-items">
                            <ng-icon name="tablerPencil" class="svg-position" (click)="openEditModal(row)"></ng-icon>
                          </span> 
                        </div>

                      </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-container *ngIf="slotModalOpen">
  <app-manage-slot [title]="'Manage Jobs/Candidates'" [userData]="slotData | async " [planDetails]="slotPlanDetails"
    [KEY]="'JOB_CANDIDATE_POSTINGS'" [content]="'jobs'" [isJobSlot]="true" (close)="onClose($event)" (onScroll)="onScroll()"
    (onSucess)="onSucess($event)" [this]="this" (onSearch)="onSearch($event)" [editMode]="editMode" 
    (onAllocate)="slotAllocatedCards = $event" [allocationCards]="slotAllocatedCards">

    <app-plan-card planCards [isJobs]="true" [cards]="slotAllocatedCards" [TOTAL]="PLANMAX"></app-plan-card> 

    <ng-container header> 
      <th>User Name</th>
      <th>Email ID</th> 
      <th colspan="2" style="padding: 0;">
        <span class="slot-td">
          <label class="w-50 bold">Slots Allowed</label>
          <label class="used bold">Slots Used</label>
        </span>
      </th>
      <th colspan="2" style="padding: 0;" >
        <span class="slot-td">
          <label class="w-50 bold">Featured Allowed</label>
          <label class="used bold">Featured Used</label>
        </span>
      </th> 
    </ng-container>
    
  </app-manage-slot>
</ng-container>
